var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.href ? 'a' : 'button',_vm._g(_vm._b({tag:"component",staticClass:"ui-button granat",class:[
            _vm.type,
            _vm.color,
            _vm.size,
            {
                'no-animation': _vm.noAnimation,
                'full-width': _vm.fullWidth,
            },
        ],attrs:{"disabled":_vm.disabled,"href":_vm.href},on:{"click":_vm.clickEvent}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("prefix"),(_vm.$slots.default && !_vm.isLoading)?_c('p',[_vm._t("default")],2):(_vm.isLoading)?_c('div',{staticClass:"loading-spinner"}):_vm._e(),_vm._t("suffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }